import { useState, useContext, useEffect, useRef } from "react";
import "./ChatWindow.css";
import ChatLine from "./ChatLine";
import { ChatContext } from "../../context/ChatContext";

export default function ChatWindow({ chatSelected, sendMsg }) {
  const { currentUser } = useContext(ChatContext);
  const [message, setMessage] = useState("");
  const messagesEndRef = useRef(null);

  // sempre que mudar o chat ou chegar nova mensagem, rola para o fim
  useEffect(() => {
    if (chatSelected) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatSelected, chatSelected?.chatLineList]);

  if (!chatSelected) {
    return <div style={{ padding: "10px" }}>Selecione um chat...</div>;
  }

  const chatUsers = chatSelected?.chatUserList || [];
  const otherUser = chatUsers[1] || { name: "Usuário" };

  function SendMessage(msg) {
    const m={
      chatID: chatSelected.chatID,
      chatLine: {
        uid: currentUser.uid,
        text: msg,
      },
    }
    console.log(`SendMessage: ${JSON.stringify(m)}`);
    
    sendMsg(m);
  }

  return (
    <div className="chat-window">
      <div className="chat-header">{otherUser.name}</div>

      <div className="chat-messages">
        {chatSelected?.chatLineList?.map((line, index) => (
          <ChatLine key={index} line={line} chatUserList={chatUsers} />
        ))}
        {/* marcador invisível no fim */}
        <div ref={messagesEndRef} />
      </div>

      <div className="chat-input-container">
        <input
          className="chat-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Digite uma mensagem..."
        />

        <button
          className="chat-send-btn"
          onClick={() => {
            if (!message.trim()) return;
            SendMessage(message);
            setMessage("");
          }}
        >
          Enviar
        </button>
      </div>
    </div>
  );
}